/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-05-23 20:30:15
 */
import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'antd'
import sensors, { parsePlaceValue } from '../../../utils/sensors'
import { useAppSelector } from '../../../app/hooks'
// import BuyInApp from '../../../images/buy-in-app.png'
import CONFIG from '../../../constants/config'
import { usePayment } from './hooks'

// const popoverContent = (
//   <img style={{ width: '273px', height: '316px' }} src={BuyInApp} alt="" />
// )

interface VipAlertProps {
  visible: boolean
  onCancel: () => void
}

const getText = () => {
  const pathname = window.location.pathname
  if (
    pathname.match(/\/attendance\/daily/) ||
    pathname.match(/\/attendance\/period/) ||
    pathname.match(/\/watermark\/data/)
  ) {
    return '数据'
  } else {
    return '照片'
  }
}

const VipAlert: React.FC<VipAlertProps> = (props) => {
  const { visible, onCancel } = props
  const groupID = useAppSelector((state) => state.group.groupId)
  const daysLimit = useAppSelector((state) =>
    state.main.config?.normal_group_data_limit_days
  )
  const onPay = usePayment()
  const containerRef = useRef(null)

  useEffect(() => {
    if (visible) {
      sensors.track('web_show_page_openapp_workgroupvip', {
        groupID: groupID,
        place: parsePlaceValue(),
        functionType: 'chooseDate'
      })
    }
  }, [visible])

  // const onPopoverVisibleChange = (visible) => {
  //   if (visible) {
  //     sensors.track('web_show_pop_open_workgroupvip', {
  //       groupID: groupID,
  //       pagePath: window.location.pathname
  //     })
  //   }
  // }

  if (visible) {
    return (
      <div className="vip-alert" ref={containerRef}>
        <span>
          开通<strong>团队会员</strong>即可查看
          {daysLimit || CONFIG.nomalGroupDatesLimit}天前的{getText()}
        </span>
        <Button
          type="link"
          size="small"
          style={{ fontWeight: 'bold' }}
          onClick={() => {
            sensors.track('web_click_button_workgroup_go_vip_trigger', {
              place: parsePlaceValue(),
              functionType: 'chooseDate',
              groupID: groupID
            })
            onPay()
            onCancel()
          }}
        >
          [立即开通]
        </Button>
        {/* <Popover
          content={popoverContent}
          placement="rightBottom"
          classNames={{ root: 'buy-in-app-popover' }}
          onVisibleChange={onPopoverVisibleChange}
        >
          <a>[如何开通]</a>
        </Popover> */}
      </div>
    )
  }
  return null
}

export default VipAlert
